export default "__VITE_ASSET__CtvfKbeu__"